__turbopack_context__.v({
  "textarea": "styles-module__1hTofq__textarea",
});
